import { Button, Pagination, Table, Tag, Input } from "antd";
import React, { useEffect, useState } from "react";
import { ExtractDate, ExtractTime, getLocalStorageItem } from "../../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { getEnquiryData, getExportData } from "./EnquiryapiFunctions";
import { saveAs } from "file-saver";
import axios from "axios";
const EnquiryDetails = () => {
  const [enquiryData, setEnquiryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const { Search } = Input;
  const location = useLocation();
  const from = location.state?.from;
  const pageSize = 10;
  function FetchEnquiry(currentPage) {
    setIsLoading(true);
    getEnquiryData(`?search=${searchTerm}&page=${currentPage}&limit=10`)
      // `isActive=1&isApproved=${approved}&isRejected=${rejected}&request_name=${searchTerm}&page=${currentPage}`
      .then((response) => {
        if (response.status) {
          setEnquiryData(response.data?.data?.enquiries);
          setCurrentPage(response.data?.data?.pagination.currentPage);
          setTotalPages(response.data?.data?.pagination.totalPages);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    FetchEnquiry(currentPage);
  }, [currentPage, searchTerm]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };

  const columnReports = [
    {
      title: "SNo.",
      dataIndex: "serial",
      key: "serial",
      className: "custom-header font-poppins text-xs",
      render: (data, record, index) => {
        return (
          <p className="text-xs font-poppins text-rgbaprimary9 font-semibold">
            {index + 1 + (currentPage - 1) * pageSize}.
          </p>
        );
      },
    },
    {
      title: "User Name",
      dataIndex: "name",
      key: "name",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {record?.name?.toUpperCase() ?? "--"}
            </p>
          </>
        );
      },
    },
    {
      title: "Contact",
      dataIndex: "mobileNumber",
      key: "mobileNumber",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {record?.mobileNumber?.toUpperCase() ?? "--"}
            </p>
          </>
        );
      },
    },
     {
      title: "City",
      dataIndex: "city",
      key: "city",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {record?.vendor?.city ?? "--"}
            </p>
          </>
        );
      },
    },
    {
      title: "Property Title",
      dataIndex: "property",
      key: "property",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">{data?.title ?? "--"}</p>
          </>
        );
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">{data ?? "--"}</p>
          </>
        );
      },
    },
    // {
    //   title: "Status",
    //   dataIndex: "resolved",
    //   key: "resolved",
    //   className: "custom-header font-poppins text-xs",
    //   render: (data, record) => {
    //     return record.resolved ? (
    //       <Tag className="font-bold bg-rgbaprimary9 text-white flex justify-center border-rgbaprimary9">
    //         Resolved
    //       </Tag>
    //     ) : (
    //       <Tag className="font-bold bg-rgbaprimary2 text-white flex justify-center border-rgbaprimary2">
    //         Pending
    //       </Tag>
    //     );
    //   },
    // },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
            </p>
          </>
        );
      },
    },
  ];

  const handleExport = () => {
    const apiendpoint = `${process.env.REACT_APP_BASE_URL}admin/get-enquiry-excel`;

    axios
      .get(apiendpoint, {
        responseType: "blob",
        headers: {
          Accept: "text/csv",
          Authorization: `Bearer ${getLocalStorageItem("token")}`,
        },
      })
      .then((res) => {
        const blob = new Blob([res.data], { type: "text/csv;charset=utf-8;" });
        saveAs(blob, "enquiry.csv");
      })
      .catch((err) => console.error("Export failed:", err));
  };

  return (
    <div>
      <ComponentTitle title={"Enquiry List"} />
      <div className="flex items-between justify-between m-2">
        <Search
          placeholder="search here..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: "25%" }}
        />
        <p
          onClick={handleExport}
          className="bg-rgbaprimary9 cursor-pointer text-white text-sm p-2 hover:bg-rgbaprimary8"
        >
          Export Enquiry Data
        </p>
      </div>

      <div
        style={{ maxHeight: "540px", overflow: "auto" }}
        className="bg-white shadow-md  shadow-[rgba(149, 157, 165, 0.2) 0px 8px 24px]"
      >
        <Table
          bordered={true}
          loading={isLoading}
          columns={columnReports}
          dataSource={enquiryData}
          pagination={false}
          className="w-screen sm:w-screen custom-table-header"
          size="small"
        />
      </div>
      <Pagination
        className="mt-2 text-xs w-full flex justify-center items-center"
        onChange={handlePageChange}
        current={currentPage}
        defaultCurrent={1}
        pageSize={pageSize}
        total={10 * totalPage}
        showSizeChanger={false}
      />
    </div>
  );
};
export default EnquiryDetails;
